import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { VIDEO_STEP_TOKEN_HEADER, VideoInterviewStepTokenService } from './video-interview-step-token.service';

/**
 * Picks up a video interview step token wherever the server issues one (BIZ-40996).
 *
 * Three responses carry it — the application that created the applicant's person record, the
 * gather read that resolved an emailed link to a person, and the `search-by-token` read that greets
 * an applicant coming back in a new tab (BIZ-41083) — and an interceptor is what lets all of them
 * hand it over without any call site changing shape. `ApiService.httpWrapper` asks for the body
 * rather than the whole response, so its callers never see a header; an interceptor sits above that
 * and sees every `HttpResponse`.
 *
 * Only captures. The token is attached by `VideoInterviewApiService`, on the two calls that need
 * it, rather than here — a credential should travel to the one endpoint that verifies it, not to
 * everything talent-app calls.
 */
@Injectable({ providedIn: 'root' })
export class VideoInterviewStepTokenInterceptor implements HttpInterceptor {

  constructor(private stepTokenService: VideoInterviewStepTokenService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      tap((event: HttpEvent<unknown>) => {
        if (event instanceof HttpResponse) {
          this.stepTokenService.store(event.headers.get(VIDEO_STEP_TOKEN_HEADER));
        }
      })
    );
  }
}
